import { postWithAuth, getWithAuth } from '../../Basic/HttpService';
import moment from 'moment';
import _ from 'lodash';

export const downloadFileWithExt = async (res, fileExt, fileName = 'Report') => {
    if (res) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.getElementById('tempDownloadPDFLink') || document.createElement('a');
        link.id = 'tempDownloadPDFLink';
        link.href = url;
        link.setAttribute('download', `${fileName}${moment().format('DD-MMM-YYYY HH:mm')}.${fileExt}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        return true;
    }
};

export const GetVORReportingExcelFile = async (params) => {
    let res = await getWithAuth(
        `VORVehicles/GetExcelFile?startDate=${params.fromDate}&endDate=${params.toDate}&Id=${params.customerID}&vehicleCategoryID=${params.vehicleCategoryID}&makeID=${params.makeID}`,
        {
            responseType: 'blob',
            returnOrgRes: true
        }
    );
    downloadFileWithExt(res, params.fileExt, 'VOR_Reporting');
};
export const GetDefectReportingExcelFile = async (params) => {
    let res = await getWithAuth(`VehicleDefects/GetDefectExcelFile?startDate=${params.fromDate}&endDate=${params.toDate}&Id=${params.customerID}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt);
};
export const GetBreakdownReportingExcelFile = async (params) => {
    let res = await getWithAuth(`VehicleBreakdowns/GetBreakdownExcelFile?startDate=${params.fromDate}&endDate=${params.toDate}&Id=${params.customerID}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'Breakdown');
};
export const GetJobReportingExcelFile = async (params) => {
    let res = await getWithAuth(`VehicleJob/GetJobExcelFile?startDate=${params.fromDate}&endDate=${params.toDate}&Id=${params.customerID}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'JobReporting');
};

export const GetSchedulesExcelFile = async (params) => {
    let res = await getWithAuth(
        `Schedules/DownLoadExcelFile?status=${params.status}
    &mode=${params.mode}
    &startDate=${params.startDate}
    &endDate=${params.endDate}`,
        {
            responseType: 'blob',
            returnOrgRes: true
        }
    );
    downloadFileWithExt(res, params.fileExt, 'Schedule');
};

export const GetVehiclesExcelFile = async (params) => {
    const { fileExt, filterValues, ...rest } = params;
    const queryParams = new URLSearchParams();

    Object.entries({ ...rest, ...(filterValues || {}), fileType: 'excel' }).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') queryParams.append(key, value);
    });

    let res = await getWithAuth(`vehicles?${queryParams.toString()}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, fileExt, 'Vehicles');
};

export const GetAddress_ListExcelFile = async (params) => {
    let res = await getWithAuth(`Address/Address_List?fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'Address_List');
};
export const GetCustomersExcelFile = async (params) => {
    let res = await getWithAuth(`customers?fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'Customers');
};
export const GetPartReceived_ListExcelFile = async (params) => {
    let res = await getWithAuth(`AdminParts/PartReceived_List?fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'PartReceived');
};
export const GetPartRequests_ListExcelFile = async (params) => {
    let res = await getWithAuth(`AdminParts/PartRequests_List?fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'PartRequests');
};
export const GetPartStockAdjustments_ListExcelFile = async (params) => {
    let res = await getWithAuth(`AdminParts/PartStockAdjustments_List?fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'PartStockAdjustments');
};
export const GetGetPurchasedPartsExcelFile = async (params) => {
    let res = await getWithAuth(`VehicleJob/GetPurchasedParts?fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'PurchasedParts');
};
export const GetdepotsExcelFile = async (params) => {
    let res = await getWithAuth(`depots?fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'Depots');
};
export const GetNotesExcelFile = async (params) => {
    let res = await getWithAuth(`${params.url}&fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, `Notes_${params.frompage}`);
};
export const GetVehicleJobItemsExcelFile = async (params) => {
    let res = await getWithAuth(`${params.url}&fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, `${params.frompage}`);
};
export const GetVehicleInspectionExcelFile = async (params) => {
    const separator = params.url.includes('?') ? '&' : '?';
    const url = `${params.url}${separator}fileType=excel`;

    let res = await getWithAuth(url, {
        responseType: 'blob',
        returnOrgRes: true
    });

    downloadFileWithExt(res, params.fileExt, `${params.frompage}`);
};

export const GetParts_ListExcelFile = async (params) => {
    const query = new URLSearchParams({
        inStock: params.inStock,
        Warehouse: params.warehouseID || '',
        fileType: 'excel',
        ...params // 👈 this will include pagination, filters, etc.
    }).toString();

    let res = await getWithAuth(`AdminParts/Parts_List?${query}`, {
        responseType: 'blob',
        returnOrgRes: true
    });

    downloadFileWithExt(res, params.fileExt, `Parts_List ${params.inStock ? 'InStock' : 'All'} ${params.warehouseID ? `Warehouse_${params.warehouseID}` : ''}`);
};

export const GetContract_ListExcelFile = async (params) => {
    let res = await getWithAuth(`Contracts/Contract_List?StatusID=${params.contractStatusID}&fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(
        res,
        params.fileExt,
        `Contract_List_${params.contractStatusID === 'A' ? 'Active' : params.contractStatusID === 'C' ? 'Completed' : 'Cancelled'}`
    );
};
export const GetVehicleTabsVORVehiclesExcelFile = async (params) => {
    let res = await getWithAuth(`VehicleTabs/GetVORVehicles_Vehicle?VehicleID=${params.VehicleID}&fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, `${params.RegNumber}-VorList`);
};
export const GetVORVehiclesExcelFile = async (params) => {
    const queryParams = new URLSearchParams();

    const allowedParams = {
        VehicleID: params.vehicleID,
        active: params.active,
        StartDate: params.startDate,
        EndDate: params.endDate,
        CustomerId: params.customerID,
        Make: params.make,
        Model: params.model,
        fileType: 'excel'
    };

    Object.entries(allowedParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') queryParams.append(key, value);
    });

    const res = await getWithAuth(`VORVehicles?${queryParams.toString()}`, {
        responseType: 'blob',
        returnOrgRes: true
    });

    downloadFileWithExt(res, params.fileExt, 'VORVehicles');
};

export const GetOutstandingDocSchedulesExcelFile = async (params) => {
    let temp = '';

    if (!_.isEmpty(params.filterValues)) {
        for (const property in params.filterValues) {
            temp = temp + `&${property}=${params.filterValues[property]}`;
        }
    }
    let res = await getWithAuth(`Schedules/OutstandingScheduleDoc/DownLoadExcelFile?received=${params.received}${temp}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'OutstandingDoc');
};

export const GetHireContractExcel = async (params) => {
    let temp = '';

    if (!_.isEmpty(params.filterValues)) {
        for (const property in params.filterValues) {
            temp = temp + `&${property}=${params.filterValues[property]}`;
        }
    }
    let res = await getWithAuth(
        `HireFleetContract/HireFleet_List?fileType=excel&FreeStock=${params.FreeStock}${
            params.vehicleJobStatus ? `&vehicleJobStatus=${params.vehicleJobStatus}` : ''
        }${temp}`,
        {
            responseType: 'blob',
            returnOrgRes: true
        }
    );
    downloadFileWithExt(res, params.fileExt, 'HireContract');
};

export const GetContractMaintenanceExcel = async (params) => {
    let temp = '';

    if (!_.isEmpty(params.filterValues)) {
        for (const property in params.filterValues) {
            temp = temp + `&${property}=${params.filterValues[property]}`;
        }
    }
    let res = await getWithAuth(`ContractMaintenance/ContractMaintenance_List?fileType=excel&FreeStock=${params.FreeStock}${temp}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'ContractMaintenance');
};

export const GetBreakdownExcel = async (params) => {
    let temp = '';

    if (!_.isEmpty(params.filterValues)) {
        for (const property in params.filterValues) {
            temp = temp + `&${property}=${params.filterValues[property]}`;
        }
    }
    let res = await getWithAuth(
        `VehicleBreakdowns/?${params.VehicleID ? `VehicleID=${params.VehicleID}&` : ''}defecttypecode=${
            params.defecttypecode ? params.defecttypecode : ''
        }&breakdownCompleted=${params.BreakdownCompleted}&fileType=excel${temp}`,
        {
            responseType: 'blob',
            returnOrgRes: true
        }
    );
    downloadFileWithExt(res, params.fileExt, 'Breakdown');
};
